import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Hero from '../Hero';
import HeroButton from '../HeroButton';
import Styles from './Styles.module.scss';

const AngleHero = ({
  title,
  description,
  talentCtaLinkTo,
  talentCtaLabel,
  brandCtaLinkTo,
  brandCtaLabel,
  analyticsData,
  ...props
}) => {
  return (
    <>
      <Hero parent={Hero.Page.MAIN} angle={true} style={{ minHeight: '550px' }}>
        <div className={Styles.container}>
          <div className={Hero.Styles.heroLeft}>
            <div>
              <h1 className={Styles.heroTitle}>{title}</h1>
              <p className={Styles.heroMainDes}>{description}</p>
              <div className={Styles.mainHeroCta}>
                <HeroButton
                  type={HeroButton.Type.WHITE}
                  className={Styles.btnCta}
                  title=''
                  href={{
                    pathname: brandCtaLinkTo,
                    query: { ...analyticsData },
                  }}>
                  {brandCtaLabel}
                </HeroButton>

                <HeroButton
                  type={HeroButton.Type.WHITE_OUTLINE}
                  className={Styles.btnCta}
                  title=''
                  href={{
                    pathname: talentCtaLinkTo,
                    query: { ...analyticsData },
                  }}>
                  {talentCtaLabel}
                </HeroButton>
              </div>
            </div>
          </div>
        </div>
      </Hero>
    </>
  );
};

AngleHero.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  talentCtaLinkTo: PropTypes.string,
  talentCtaLabel: PropTypes.string,
  brandCtaLinkTo: PropTypes.string,
  brandCtaLabel: PropTypes.string,
};

export default AngleHero;
